import { useDispatch, useSelector } from "react-redux";
import { ReceiptLongOutlinedIcon } from "../components/icons";
import useGoTo from "../hooks/useGoTo";
import Button from "react-bootstrap/Button";
import ProductsListTotem from "../components/ProductsListTotem";
import FloatingCartSummary from "./FloatingCartSummary";
import { elementScrollTo } from "../utils/domScrollTo";
import { setActiveGroupId } from "../ducks/productsSlice";
import RequestWaiterButton from "../components/RequestWaiterButton";
import { useDisableZoom } from "../hooks/useDisableZoom";
import BarcodeScanner from "../components/BarcodeScanner";
import { VERSION } from "../ducks/consts";
import filterProductsBySearch from "../utils/searchProducts";
import useMenuCatalog from "../hooks/useMenuCatalog";

export default function GroupedProductsTotemView({ isCartVisible }) {
  useDisableZoom();
  const dispatch = useDispatch();
  const goTo = useGoTo();

  const {
    id: shopId,
    tableId,
    pictureUrl,
    inLocoText,
  } = useSelector((state) => state.shop);

  const { searchText, activeGroupId } = useSelector((state) => state.products);

  // A coluna de grupos não muda com a busca: ela vale para o cardápio todo, e
  // o resultado da busca aparece no lugar dos produtos do grupo ativo.
  const {
    availableProducts,
    productsByGroup,
    visibleGroups: availableGroups,
    onProductSelect,
  } = useMenuCatalog();

  const activeGroup =
    availableGroups.find((g) => g.id === activeGroupId) || availableGroups[0];

  const handleGroupClick = (group) => () => {
    elementScrollTo("totem-products-column", 0, "auto");
    dispatch(setActiveGroupId({ activeGroupId: group.id }));
  };

  const productsToShow = searchText
    ? filterProductsBySearch(availableProducts, searchText).filter(
        (p) => !!availableGroups.find((g) => g.id === p.groupId),
      )
    : (activeGroup && productsByGroup[activeGroup.id]) || [];

  return (
    <div className="totem-home">
      <BarcodeScanner />
      <nav className="totem-groups" aria-label="Categorias">
        {pictureUrl && (
          <img
            src={pictureUrl}
            alt="Logo da loja"
            className="totem-groups__logo"
          />
        )}
        {inLocoText && <p className="totem-groups__place">{inLocoText}</p>}

        <ul className="totem-groups__list">
          {availableGroups.map((group) => {
            const isActive = !searchText && group.id === activeGroup?.id;
            return (
              <li key={group.id}>
                <button
                  type="button"
                  className={`totem-group${
                    isActive ? " is-active border-color-shop" : ""
                  }`}
                  aria-current={isActive ? "true" : undefined}
                  onClick={handleGroupClick(group)}
                >
                  <span
                    className="totem-group__img"
                    style={
                      group.image
                        ? { backgroundImage: `url("${group.image}")` }
                        : undefined
                    }
                  >
                    {!group.image && (
                      <span className="totem-group__initial">
                        {group.name.charAt(0)}
                      </span>
                    )}
                  </span>
                  <span
                    className={`totem-group__name${
                      isActive ? " product-price-color-shop" : ""
                    }`}
                  >
                    {group.name}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>

        {inLocoText && (
          <div className="totem-groups__actions">
            <Button
              className="totem-groups__action"
              variant="outline-shop"
              onClick={() => goTo(`/status-inloco`)}
            >
              <ReceiptLongOutlinedIcon /> Ver consumo
            </Button>
            <RequestWaiterButton
              className="totem-groups__action"
              shopId={shopId}
              tableId={tableId}
            />
          </div>
        )}

        <small className="totem-groups__version">{VERSION}</small>
      </nav>
      <main id="totem-products-column" className="totem-products">
        {activeGroup && (
          <ProductsListTotem
            searchText={searchText}
            group={activeGroup}
            products={productsToShow}
            onProductSelect={onProductSelect}
          />
        )}
        {isCartVisible && <FloatingCartSummary />}
      </main>
    </div>
  );
}
